/* eslint-disable @typescript-eslint/naming-convention */
import {
  Component,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  effect,
} from '@angular/core';
import { ActiveSectionState } from '@ansys-internal/awf-angular/workspace';
import { Unit } from '@ansys-internal/awc-angular/design';
import {
  Grid,
  GridComponent,
  GridFillMode,
} from '@ansys-internal/awc-angular/layouts';
import { requirementSections } from '../../../shared/models/sections.model';
import { Icons } from '@ansys-internal/awc-angular/icons';
import { WorkspaceTabSection } from '@ansys-internal/awf-angular/contributions';
import {
  ConceptSections,
  ConceptSubSection,
} from 'src/app/shared/enums/concept.enum';
import { State } from '@ansys-internal/awf-angular/store';
import { ButtonSize, ButtonType } from '@ansys-internal/awc-angular/buttons';
import { startWith, Subject, takeUntil } from 'rxjs';
import { SectionCardTab } from '../section-card/types/section-card-tab.type';
import { ArchitectureService } from 'src/app/shared/services/architecture.service';
import { ActiveConceptState } from 'src/app/state/lib/active-concept.state';
import { ConceptService } from 'src/app/shared/services/concept.service';
import { PageState, PageStateModel } from '../../../state/lib/app-page.state';
import { LoadingContentScreenComponent } from '../loading-content-screen/loading-content-screen.component';
import { DataDisplayComparisonToolComponent } from '../data-display-comparison-tool/data-display-comparison-tool.component';
import { DataDisplayPanelComponent } from '../data-display-panel/data-display-panel.component';
import { LeftSectionComponent } from '../left-section/left-section.component';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { ActiveConceptIDState } from '../../../state/lib/active-concept-id.state';

const gridGap = {
  value: 1,
  unit: Unit.REM,
};

@Component({
    selector: 'app-concept-layout',
    templateUrl: './concept-layout.component.html',
    styleUrls: ['./concept-layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        LoadingContentScreenComponent,
        DataDisplayComparisonToolComponent,
        DataDisplayPanelComponent,
        LeftSectionComponent,
        GridComponent,
        CommonModule,
    ]
})
export class ConceptLayoutComponent implements OnDestroy {
  public checked: boolean = true;
  protected config: Grid = {
    columnGap: gridGap,
    columns: [{ value: 320, unit: Unit.PX }, GridFillMode.FILL],
    rowGap: gridGap,
    rows: [GridFillMode.FILL],
  };
  protected page!: PageStateModel;
  protected readonly ConceptSections = ConceptSections;
  protected readonly Icons = Icons;
  protected selectedSection!: ConceptSections;
  protected type: ButtonType = ButtonType.PRIMARY;
  protected size: ButtonSize = ButtonSize.LARGE;
  protected readonly ConceptSubSection = ConceptSubSection;
  private ngUnsubscribe: Subject<boolean> = new Subject<boolean>();

  /**
   * Study layout component constructor
   */
  constructor(
    private state: State,
    protected architectureService: ArchitectureService,
    protected conceptService: ConceptService,
    private _cdr: ChangeDetectorRef,
    private ar: ActivatedRoute
  ) {
    const selectedSection = this.state.value(ActiveSectionState);
    if (selectedSection) {
      this.selectedSection = selectedSection.type as ConceptSections;
    }

    effect(() => {
      this.conceptService.loading() && this._cdr.markForCheck();
    });
  }

  ngOnInit(): void {
    this.state
      .get(PageState)
      .pipe(
        startWith(this.state.value(PageState)),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((page: PageStateModel) => {
        this.page = page;
        this._cdr.detectChanges();
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next(true);
    this.ngUnsubscribe.complete();
    this.state.set(ActiveConceptState, undefined);
  }
}
